import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface BulkActionBarProps {
  selectedCount: number;
  onMoveToGroup: () => void;
  onChangeStatus: () => void;
  onClearSelection: () => void;
}

export function BulkActionBar({
  selectedCount,
  onMoveToGroup,
  onChangeStatus,
  onClearSelection,
}: BulkActionBarProps) {
  if (selectedCount === 0) return null;

  return (
    <div className="sticky top-0 z-10 flex items-center gap-3 rounded-lg bg-ndd-800 px-4 py-3 shadow-lg">
      <span className="text-sm font-medium text-white">
        {selectedCount} animal{selectedCount !== 1 ? 's' : ''} selected
      </span>
      <div className="flex-1 flex gap-2">
        <Button variant="secondary" size="sm" onClick={onMoveToGroup}>
          Move to Group
        </Button>
        <Button variant="secondary" size="sm" onClick={onChangeStatus}>
          Change Status
        </Button>
      </div>
      <button
        type="button"
        onClick={onClearSelection}
        className="text-ndd-300 hover:text-white"
        aria-label="Clear selection"
      >
        <X size={18} />
      </button>
    </div>
  );
}
